import { animate, state, style, transition, trigger } from "@angular/animations";

export const slideInAnimation = trigger("slideIn", [
    state("void", style({ transform: "translateX(-100%)" })),
    transition(":enter", [
        animate("300ms ease-in", style({ transform: "translateX(0)" })),
    ]),
]);
